/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveMainRegistryFetcher,
  CurveMainRegistryFetcherInterface,
} from "../CurveMainRegistryFetcher";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "_addressProvider",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddressProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryIsTheSame",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum RegistryId",
        name: "id",
        type: "uint8",
      },
    ],
    name: "RegistryNotFoundById",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ICurveAddressProviderLike",
        name: "curveAddressProvider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum RegistryId",
        name: "registryId",
        type: "uint8",
      },
    ],
    name: "DataFetcherCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDRESS_PROVIDER",
    outputs: [
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRY_ID",
    outputs: [
      {
        internalType: "enum RegistryId",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveMainRegistryFetcherConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveMainRegistryFetcherConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveMainRegistryFetcher__factory extends ContractFactory {
  constructor(...args: CurveMainRegistryFetcherConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveMainRegistryFetcher";
  }

  deploy(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveMainRegistryFetcher> {
    return super.deploy(
      _repository,
      _addressProvider,
      overrides || {}
    ) as Promise<CurveMainRegistryFetcher>;
  }
  getDeployTransaction(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _addressProvider,
      overrides || {}
    );
  }
  attach(address: string): CurveMainRegistryFetcher {
    return super.attach(address) as CurveMainRegistryFetcher;
  }
  connect(signer: Signer): CurveMainRegistryFetcher__factory {
    return super.connect(signer) as CurveMainRegistryFetcher__factory;
  }
  static readonly contractName: "CurveMainRegistryFetcher";
  public readonly contractName: "CurveMainRegistryFetcher";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveMainRegistryFetcherInterface {
    return new utils.Interface(_abi) as CurveMainRegistryFetcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveMainRegistryFetcher {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveMainRegistryFetcher;
  }
}
